<template>
  <div>
    <Header/>
    <Features/>
    <DetailedFeatures/>
  </div>
</template>

<script>
  import Header from "./Header";
  import Features from "./Features";
  import DetailedFeatures from "./DetailedFeatures";
  export default {
    name: "Main",
    components: {DetailedFeatures, Features, Header},
    created() {
      this.$store.commit("SET_PAGE_TYPE", "university");
      this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "linear-gradient(104.96deg, #27A949 0.72%, #5CF5C8 94.5%)");
      this.$store.commit("SET_THEME_COLOR", "#27A949");
      // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
    }
  }
</script>

<style scoped>

</style>
